<template>
  <div>
    <v-row dense class="pb-2 align-center">
      <v-col
        cols="12"
        md="6"
        offset-md="6"
        offset-lg="8"
        lg="4"
        class="d-flex text-right align-center"
      >
        <v-text-field
          v-model="searchQuery"
          append-icon="mdi-magnify"
          class="mr-md-2"
          solo
          hide-details
          dense
          clearable
          placeholder="Search Project RFQ"
        ></v-text-field>
        <v-btn icon small class="ml-2" @click="refresh">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-card v-if="!rfqs || rfqs.length < 1">
      <v-card-text>
        <div class="text-center">
          No RFQ found...
        </div>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      hide-default-header
      hide-default-footer
      :items="rfqs"
      :search="searchQuery"
      no-data-text="No RFQ found"
    >
      <template v-slot:body="item">
        <div v-for="rfq in item.items" :key="rfq.id">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 0"
              class="pa-2 cursor-pointer"
              @click="$router.push(`/dealer/rfq/${rfq.id}`)"
            >
              <div
                class="project d-flex align-center justify-space-between flex-wrap flex-md-nowrap"
              >
                <div class="d-flex align-center pr-2">
                  <div>
                    <v-img
                      width="100"
                      height="80"
                      src="https://picsum.photos/id/11/100/60"
                    ></v-img>
                  </div>
                  <div class="ml-1">
                    <h6 class="primary--text pb-0 mb-0">
                      <strong>{{ rfq.project.name }}</strong>
                    </h6>
                    <div>
                      <strong>Contractor: </strong>
                      <strong>
                        XYZ, Contractor
                      </strong>
                    </div>
                    <div>
                      <strong>Architect: </strong>
                      <span
                        >{{
                          rfq.project.selected_architect &&
                          rfq.project.selected_architect.company
                            ? rfq.project.selected_architect.company
                            : "N/A"
                        }},
                      </span>
                      <strong
                        >{{
                          rfq.project.selected_architect &&
                          rfq.project.selected_architect.name
                            ? rfq.project.selected_architect.name
                            : "N/A"
                        }}
                      </strong>
                    </div>
                    <div>
                      <strong>Project Address: </strong>
                      <span
                        >{{
                          rfq.project.address.address_line_1 &&
                            rfq.project.address.address_line_1
                        }}
                        {{
                          rfq.project.address.address_line_2 &&
                            rfq.project.address.address_line_2
                        }},
                        {{
                          rfq.project.address.city && rfq.project.address.city
                        }}
                        {{
                          rfq.project.address.state && rfq.project.address.state
                        }}
                        {{
                          rfq.project.address.zip && rfq.project.address.zip
                        }}</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-grow-1 align-center justify-md-end justify-space-between mt-2 mt-md-0"
                >
                  <div class="d-flex">
                    <div class="ml-2 mr-3 mr-lg-5">
                      <span
                        >Request Date:
                        {{ new Date(rfq.sent_on).toLocaleDateString() }}</span
                      >
                      <br />
                      <span>Status: </span>
                      <span class="success--text text-capitalize">{{
                        rfq.status
                      }}</span>
                    </div>
                  </div>

                  <v-menu offset-y left>
                    <template v-slot:activator="{ on }">
                      <transition name="slide-fade" mode="out-in">
                        <v-btn icon v-on="on">
                          <v-icon size="32" color="primary">
                            mdi-dots-horizontal
                          </v-icon>
                        </v-btn>
                      </transition>
                    </template>
                    <v-list dense>
                      <v-list-item @click="declineProject(rfq)">
                        <v-icon size="18" class="mr-1"
                          >mdi-minus-circle-outline</v-icon
                        >
                        <v-list-item-title>Decline</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteDealerProject(rfq)">
                        <v-icon size="18" class="mr-1">mdi-delete</v-icon>
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </v-card>
          </v-hover>
          <v-divider></v-divider>
        </div>
        <!-- <div
          v-if="rfqs && rfqs.length && pagination"
          class="text-center pb-3"
        >
          <v-pagination
            v-model="pagination.page"
            :length="pagination.totalPages"
            @input="paginaterfqs"
          ></v-pagination>
        </div> -->
      </template>
    </v-data-table>

    <DeleteDealerProject
      v-if="deleteDealerModal && selectedRfq"
      :dialog="deleteDealerModal"
      :project="selectedRfq"
      @refresh="refresh"
      @close="deleteDealerModal = false"
    />

    <DeclineProject
      v-if="declineModal && selectedRfq"
      :dialog="declineModal"
      :rfq="selectedRfq"
      @refresh="refresh"
      @close="declineModal = false"
    />
  </div>
</template>

<script>
import DeleteDealerProject from "@/components/rfq/DeleteDealerProject";
import DeclineProject from "@/components/rfq/DeclineProject";
export default {
  components: {
    DeleteDealerProject,
    DeclineProject
  },
  props: {
    rfqList: { type: Array, default: null },
    paginationObj: { type: Object, default: null },
    isLoading: { type: Boolean, default: false }
  },
  data() {
    return {
      rfqs: [],
      selectedRfq: null,
      pagination: null,
      deleteDealerModal: false,
      declineModal: false,
      searchQuery: null,
      headers: [
        {
          text: "project",
          value: "name"
        },
        {
          text: "actions",
          value: "action"
        }
      ]
    };
  },
  watch: {
    rfqList(val) {
      if (val && val.length) {
        this.rfqs = JSON.parse(JSON.stringify(val));
      }
    },
    paginationObj(val) {
      if (val) {
        this.pagination = JSON.parse(JSON.stringify(val));
      }
    }
  },
  created() {
    if (this.rfqList && this.rfqList.length) {
      this.rfqs = JSON.parse(JSON.stringify(this.rfqList));
    }
    if (this.paginationObj) {
      this.pagination = JSON.parse(JSON.stringify(this.paginationObj));
    }
  },
  methods: {
    deleteDealerProject(item) {
      this.selectedRfq = { ...item };
      this.deleteDealerModal = true;
    },
    declineProject(item) {
      this.selectedRfq = { ...item };
      this.declineModal = true;
    },
    refresh() {
      this.declineModal = false;
      this.$emit("refresh", true);
    }
    // paginaterfqs(value) {
    //   this.$emit("paginate", value);
    // }
  }
};
</script>
